
import { baseCommand } from "./basecommand";

// {
//     "type":"dev",
//     "data":{
//         "command" : "auto_exposure",
//         "value": 11.5
//     }
// }

type devTypename = "dev"
type command = "auto_exposure"
type commandValue = number;
type datatype = {
    "command": command;
    "value": commandValue;
}

type pscommand<T> = {
    "type": T extends command ? devTypename : never;
    "data": T extends command ? datatype : never;
};

export type autoexposureCommand = pscommand<command>;

export class autoexposure extends baseCommand {
    constructor(private num: commandValue) {
        super();
    }

    public object(): autoexposureCommand {
        return {
            "type":"dev",
            "data":{
                "command" : "auto_exposure",
                "value" : this.num
            }
        }
    }
}
